import { Box, TextBody, get } from '@ally/metronome-ui'
import React from 'react'
import styled from 'styled-components'
import { AccountDetails } from '../../../types'
import { AccountOwnershipTypeModal } from './AccountOwnershipTypeModal'
import { NonPrintingWrapper } from '../../../utils/NonPrintingWrapper'

const StyledBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${get.space('sm')};
`
export const AccountOwnership: React.FC<{
  account: AccountDetails
  accountLabel: string
}> = ({ account, accountLabel }) => {
  const getDistributionCopy = (): string => {
    if (account.distributionType === 'I') {
      return 'In trust for'
    }
    if (account.distributionType === 'D') {
      return 'Payable on death'
    }
    return ''
  }

  if (
    account.distributionType &&
    account.beneficiaries &&
    account.beneficiaries.length
  ) {
    return (
      <Box pb="lg">
        <TextBody tag="p" size="sm" weight="bold">
          Account ownership type
        </TextBody>
        <StyledBox>
          <TextBody tag="p" size="sm" weight="normal">
            {getDistributionCopy()}
          </TextBody>
          <NonPrintingWrapper>
            <AccountOwnershipTypeModal
              account={account}
              accountLabel={accountLabel}
            />
          </NonPrintingWrapper>
        </StyledBox>
      </Box>
    )
  }
  return <></>
}
